// @flow

import { PureComponent } from 'react';
import { connect } from 'react-redux';

import formatDateTime from 'shared/libs/date-time-worker/formatDateTime';
import * as selector from 'shared/selectors';

type PropsType = {
  /** дата и время */
  dateTime: string,
  /** формат даты и времени */
  format: string,
  /** текущая таймзона */
  timezone: string,
  /** текущая локаль */
  locale: string,
  /** таймзона, которую нужно использовать вместо текущей */
  forceTimezone?: string,
  /** использовать ли таймзону */
  isWithoutTimezone?: boolean
};

export class DateTime extends PureComponent<PropsType> {
  render() {
    const { dateTime, format, timezone, locale, forceTimezone, isWithoutTimezone } = this.props;

    if (!dateTime) return null;

    return formatDateTime(dateTime, format, {
      locale,
      timezone: forceTimezone || timezone,
      isWithoutTimezone
    });
  }
}

const mapStateToProps = (state) => ({
  timezone: selector.getCurrentTimezone(state),
  locale: selector.getCurrentLocale(state)
});

DateTime.defaultProps = {
  forceTimezone: null,
  isWithoutTimezone: false
};

export default connect(mapStateToProps)(DateTime);
